"use client";
import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { WcStack } from "../layout/Stack/Stack";
export const WcDroppable = (props) => {
  const { isOver, setNodeRef } = useDroppable({
    disabled: props.disabled,
    id: props.id,
  });
  return (
    <WcStack width="100%" ref={setNodeRef}>
      {props.children}
    </WcStack>
  );
};
